export const SETTINGS_SECTION_IDS = [
  "general",
  "profile",
  "trading",
  "connected-accounts",
  "access",
  "security",
] as const;

export type SettingsSectionId = (typeof SETTINGS_SECTION_IDS)[number];

export interface AppSettingsSearch {
  settings?: SettingsSectionId;
}

export interface SettingsSectionDefinition {
  id: SettingsSectionId;
}

export const SETTINGS_SECTION_REGISTRY: readonly SettingsSectionDefinition[] = [
  {
    id: "general",
  },
  {
    id: "profile",
  },
  {
    id: "trading",
  },
  {
    id: "connected-accounts",
  },
  {
    id: "access",
  },
  {
    id: "security",
  },
] as const;

export function isSettingsSectionId(value: unknown): value is SettingsSectionId {
  return SETTINGS_SECTION_IDS.includes(value as SettingsSectionId);
}

export function normalizeSettingsSectionId(
  value: unknown,
): SettingsSectionId | undefined {
  return isSettingsSectionId(value) ? value : undefined;
}

export function normalizeAppSettingsSearch(
  raw: Record<string, unknown>,
): AppSettingsSearch {
  const settings = normalizeSettingsSectionId(raw.settings);
  return settings ? { settings } : {};
}

export function applySettingsSectionToSearch(
  search: Record<string, unknown>,
  section: SettingsSectionId,
): Record<string, unknown> {
  return {
    ...search,
    settings: section,
  };
}

export function removeSettingsSectionFromSearch(
  search: Record<string, unknown>,
): Record<string, unknown> {
  const nextSearch = {
    ...search,
  };

  delete nextSearch.settings;
  return nextSearch;
}
